import React from 'react';

/**
 * Compact number-input field with a small label above.
 * Used by MiniMapEditor's property panels — kept as its own file so multiple
 * panels can share it without pulling in the whole editor.
 */
export default function NumField({ label, value, onChange, step = 1, testid }) {
  const [local, setLocal] = React.useState(value ?? 0);
  React.useEffect(() => { setLocal(value ?? 0); }, [value]);
  return (
    <div>
      <div className="text-[10px] uppercase font-black tracking-widest text-slate-400 mb-1">{label}</div>
      <input
        type="number"
        step={step}
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        onBlur={() => onChange(Number(local))}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.currentTarget.blur(); } }}
        className="w-20 bg-slate-950 border border-slate-700 rounded px-2 py-1 text-white text-xs text-right"
        data-testid={testid}
      />
    </div>
  );
}
